<template>
  <Modal class-name="vertical-center-modal" v-model="isDetail" title="佣金详情">
    <div class="form-wrapper">
      <el-row>
        <el-col :span="8" class="text-right padding-5">
          <label>订单号：</label>
        </el-col>
        <el-col :span="16" class="padding-5" style="word-break: break-all;">
          {{ info.orderNo }}
        </el-col>
      </el-row>
    </div>
    <div class="form-wrapper">
      <el-row>
        <el-col :span="8" class="text-right padding-5">
          <label>官方佣金：</label>
        </el-col>
        <el-col :span="16" class="padding-5">
          {{ info.commissionTotal }}元
        </el-col>
      </el-row>
    </div>
    <div class="form-wrapper">
      <el-row>
        <el-col :span="8" class="text-right padding-5">
          <label>结算时间：</label>
        </el-col>
        <el-col :span="16" class="padding-5">
          {{ info.settleTime }}
        </el-col>
      </el-row>
    </div>
    <div class="form-wrapper">
      <el-row>
        <el-col :span="8" class="text-right padding-5">
          <label>下单用户：</label>
        </el-col>
        <el-col :span="16" class="padding-5">
          {{ info.sourceId }}
        </el-col>
      </el-row>
    </div>
    <div class="form-wrapper">
      <el-row>
        <el-col :span="8" class="text-right padding-5">
          <label>订单状态：</label>
        </el-col>
        <el-col :span="16" class="padding-5">
          <span v-if="info.state == 6">待出票</span>
          <span v-if="info.state == 8">已出票</span>
          <span v-if="info.state == 9">已读票</span>
          <span v-if="info.state == 10">未结算</span>
          <span v-if="info.state == 20">已结算</span>
          <span v-if="info.state == 15">订单失效</span>
        </el-col>
      </el-row>
    </div>
    <div class="form-wrapper">
      <el-row>
        <el-col :span="8" class="text-right padding-5">
          <label>佣金：</label>
        </el-col>
        <el-col :span="16" class="padding-5">
          <el-row>
            <el-col>共{{ info.commission }}元</el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-col v-if="info.list.length > 0" class="detail-table">
          <Table border
                 :show-header="false"
                 :columns="columns"
                 :data="info.list">
          </Table>
        </el-col>
      </el-row>
    </div>
    <div class="form-wrapper">
      <el-row>
        <el-col :span="8" class="text-right padding-5">
          <label>运营所得佣金：</label>
        </el-col>
        <el-col :span="16" class="padding-5">
          {{ info.commissionRemain }}元
        </el-col>
      </el-row>
    </div>
    <div slot="footer">
      <div class="footer-wrapper">
        <span class="btn confirm-btn" @click="handelSure">确定</span>
      </div>
    </div>
  </Modal>
</template>

<script>
import { Modal, Table } from 'view-design'
import order from '@/javaApi/order'
const orderModel = new order()
export default {
  name: "CommissionDetail",
  components: { Modal,Table },
  props: {},
  created() {},
  data: function () {
    return {
      isDetail: false,
      loading:false,
      columns: [
        {
          key: 'headImgUrl',
          render: (h, params) => {
            let movieImage = params.row.headImgUrl;
            let renderData = []
            if(movieImage) {
              renderData.push(
                h('img',{
                  attrs:{
                    src: movieImage, style: 'width: 22px;margin:5px auto;float:left;cursor:pointer;border-radius:11px;'
                  },
                })
              )
            }
            return renderData;
          }
        },
        {
          key: 'id',
        },
        {
          key: 'level',
          width: 80,
        },
        {
          key: 'commission',
        }
      ],
      info:{
        orderNo: undefined,
        commissionTotal: undefined,
        settleTime: undefined,
        sourceId: undefined,
        state: undefined,
        commission: undefined,
        list: [],
        operateCommission: undefined,
      }
    }
  },
  methods: {
    init: function (row) {
      orderModel.getCommissionInfo({uuid: row.uuid, platformUuid: row.platformUuid}).then((response) => {
        var res = response.data
        if(res.code != 200){
          this.$Message.error(res.message)
          return
        }
        this.info = {
          orderNo: res.data.order.orderNo,
          commissionTotal: parseFloat(res.data.order.commissionTotal).toFixed(2),
          settleTime: res.data.order.settleTime,
          sourceId: res.data.order.sourceId,
          state: res.data.order.state,
          commission: parseFloat(res.data.order.commissionTotal - res.data.order.commissionRemain).toFixed(2),
          list: res.data.order.vos,
          commissionRemain: parseFloat(res.data.order.commissionRemain).toFixed(2),
        }
      this.isDetail = true
      }).catch((err) => {
        console.log(err)
        this.$Message.error('加载佣金详情失败,请稍后再试!')
      })
    },
    handelCancel: function () {
      this.isDetail = false
    },
    handelSure: function () {
      this.handelCancel();
    },
  }
}
</script>

<style scoped>
.text-right{
  text-align: right;
}
.padding-5{
  padding: 5px;
}
.detail-table{
  margin: 10px 0;
}
.normal-font {
  color: #FF4F76;;
  font-size: 14px;
}
>>> .ivu-modal{
  top: 50px;
}
>>> .ivu-modal-body {
  padding: 16px 16px 0px 16px;
}
>>> .ivu-modal-content{
  border-radius: 8px;
}
>>>.vertical-center-modal .ivu-modal-footer {
  border-top: none;
  padding: 12px 18px 20px 18px;
  text-align: right;
}
.footer-wrapper {
  display: flex;
  min-width: 0;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.footer-wrapper .btn {
  display: block;
  width: 100%;
  font-size: 16px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  border-radius: 20px;
  text-align: center;
}

.footer-wrapper .btn.confirm-btn {
  background: #ff8622;
  color: #fff;
}

.footer-wrapper .btn.cancel-btn {
  border: 1px solid #eeeeee;
  color: #222222;
  background: #F2F2F2;
  margin-right: 15px;
}
>>>.ivu-table-cell{
  padding: 0 5px;
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/h5/official/order/modal/CommissionDetail.vue